// import TIM from 'tim-js-sdk'
import COSSDK from 'cos-js-sdk-v5'
import { useTim } from '@/utils'

let tim = {}
const pathName = location.pathname
const paths = ['livebroadcast', 'livePrefecture']
const pass = paths.some((item) => pathName.includes(item))
if (useTim() && pass) {
  // 初始化 SDK 实例
  tim = window.TIM.create({
    SDKAppID: Number(process.env.VUE_APP_APP_ID)
  })

  window.setLogLevel = tim.setLogLevel

  // 0 普通级别，日志量较多，接入时建议使用
  // 1 release级别，SDK 输出关键信息，生产环境时建议使用
  // 2 告警级别，SDK 只输出告警和错误级别的日志
  // 3 错误级别，SDK 只输出错误级别的日志
  // 4 无日志级别，SDK 将不打印任何日志
  const level = process.env.NODE_ENV !== 'production' ? 1 : 2
  // 无日志级别
  tim.setLogLevel(level)

  // 注册 cos
  tim.registerPlugin({ 'cos-js-sdk': COSSDK })
}
export default tim
